import { useStyles } from './styles'

export const NewPlatformMark = () => {
  const { classes } = useStyles()

  return (
    <div className={classes.root}>
      <span>BETA</span>
    </div>
  )
}
